import useIframePlugin from './use-iframe-plugin';
import useIframeEncrypt from './use-iframe-encrypt';
export default { useIframePlugin, useIframeEncrypt };

export { useIframePlugin, useIframeEncrypt };
